<template>
	<div style="padding: 20px;">
		<!-- 搜索栏 -->
		<div style="margin-bottom: 20px;">
			<el-input v-model="schoolName" placeholder="输入学校名称搜索" style="width: 280px; margin-right: 10px;" clearable />
			<el-button type="primary" @click="getList">搜索</el-button>
		</div>

		<!-- 学校学科列表 -->
		<el-table :data="tableData" border stripe>
			<el-table-column label="序号" prop="schoolId" width="100" align="center">
				<template slot-scope="scope">
					{{(pageNum-1)*pageSize+scope.$index+1}}
				</template>
			</el-table-column>
			<el-table-column label="学校名称" prop="schoolName" min-width="180" align="center" />

			<!-- 学段学科展示 -->
			<el-table-column label="学科配置" min-width="300" >
				<template slot-scope="scope">
					<div v-for="(item, index) in scope.row.subjectList" :key="index" style="margin-bottom:5px;">
						<el-tag type="success">{{ item.name }}</el-tag>
						<span style="margin-left:5px;">{{forStr( item.strList) || '未配置' }}</span>
					</div>
					<span v-if="scope.row.subjectList.length === 0" style="color:#999">未配置学科</span>
				</template>
			</el-table-column>

			<!-- 操作 -->
			<el-table-column label="操作" width="120" align="center">
				<template slot-scope="scope">
					<el-button type="text" @click="toEdit(scope.row)">
						修改
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination @size-change="getList" @current-change="getList" :current-page="pageNum" :page-sizes="[10,20,30]"
			:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
			style="margin-top:20px; text-align:right;" />
	</div>
</template>

<script>
	export default {
		name: "SchoolSubjectList",
		data() {
			return {
				schoolName: "",
				pageNum: 1,
				pageSize: 10,
				total: 0,
				tableData: []
			};
		},
		created() {
			this.getList();
		},
		methods: {
			// 获取学校学科列表
			getList(val) {
				if(val){
					this.pageNum=val
				}
				this.API.get(this.API.admin.getschoolListWithSubject, {
					schoolName: this.schoolName,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}).then(res => {
					// if (res.code === 0) {
					let list = res.data.data?.records?.map(v => {
						v.subjectList = []
						v.stageSubjectList?.map(a => {
							if (a.stageCode == 1) {
								if (v.subjectList[0]?.name) {
									v.subjectList[0].strList.push(a.subjectNames)
								} else {
									v.subjectList[0] = {
										name: '小学',
										strList: [a.subjectNames]
									}
								}
							}
							if (a.stageCode == 2) {
								if (v.subjectList[1]?.name) {
									v.subjectList[1].strList.push(a.subjectNames)
								} else {
									v.subjectList[1] = {
										name: '初中',
										strList: [a.subjectNames]
									}

								}
							}
							if (a.stageCode == 3) {
								if (v.subjectList[2]?.name) {
									v.subjectList[2].strList.push(a.subjectNames)
								} else {
									v.subjectList[2] = {
										name: '高中',
										strList: [a.subjectNames]
									}
								}
							}
							if (a.stageCode == 4) {
								if (v.subjectList[3]?.name) {
									v.subjectList[3].strList.push(a.subjectNames)
								} else {
									v.subjectList[3] = {
										name: '中职',
										strList: [a.subjectNames]
									}
								}
							}

						})
						return {
							...v
						}
					})
					console.log('list', list)
					this.tableData = list
					this.total = res.data.data.total;
					// }
				});
			},
			forStr(val) {
				if (!val) return ''

				return val.join(' ')
			},
			// 跳转到修改页面（路由跳转）
			toEdit(row) {
				this.$router.push({
					path: "/admin/school/subject/edit",
					query: {
						schoolId: row.schoolId,
						schoolName: row.schoolName
					}
				});
			}
		}
	};
</script>